import React from "react";

import { Context, fetchClasses } from "../../../teacherStore";
import ClassList from "../../../templates/teacher/ClassList";

export default () => {
  const { state, dispatch } = React.useContext(Context);

  React.useEffect(() => {
    dispatch(fetchClasses());
  }, [dispatch]);

  return <ClassList classes={state.classes} />;
};
